import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a627835"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  "data-enter-scope": "save",
  class: "order-comment-editor"
}
const _hoisted_3 = { class: "editor-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _directive_enter_action = _resolveDirective("enter-action")!

  return (_ctx.readOnly)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.modelValue || '—'), 1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_a_textarea, {
          value: _ctx.draft,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
          maxlength: 200,
          placeholder: _ctx.generateTitle('请输入备注/留言信息'),
          "auto-size": { minRows: 2, maxRows: 5 },
          "show-count": ""
        }, null, 8, ["value", "placeholder"]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            loading: _ctx.saving,
            disabled: !_ctx.canSave,
            onClick: _ctx.saveComment
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.generateTitle('保存')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])), [
            [_directive_enter_action, () => _ctx.saveComment(), "save"]
          ])
        ])
      ]))
}